
// roadmap - exibe o mapa de vias padrão. Esse é o tipo de mapa padrão.
// satellite - exibe imagens de satélite do Google Earth
// hybrid - exibe uma combinação de visualizações normais e de satélite
// terrain - exibe um mapa físico baseado em informações do terreno.

// streetview - (extra) fazer ???????????????????


/**
 * @enum {string}
 */
export default {
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  HYBRID: 'hybrid',
  TERRAIN: 'terrain',
  STREETVIEW: 'streetviewmap'
};
